import { Component, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { CutSheetService } from "apps/resource-portal/src/app/services/cut-sheet.service";
import { DialogService } from "libs/core/src/lib/services/dialog.service";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "concourse-add-account-dialog",
  templateUrl: "./add-account-dialog.component.html",
  styleUrls: ["./add-account-dialog.component.scss"],
})
export class AddAccountDialogComponent implements OnInit {
  public accountForm: UntypedFormGroup;
  $unsubscribe = new Subject<void>();
  title = "";
  accountName:any = "";
  constructor(
    public activeModal: NgbActiveModal,
    private _dialogService: DialogService,
    private _cutsheetService: CutSheetService
  ) {}

  ngOnInit(): void {
    console.log(this.accountName);

    this.accountForm = new UntypedFormGroup({
      name: new UntypedFormControl("", Validators.required),
      phone: new UntypedFormControl(""),
      email: new UntypedFormControl("", Validators.email),
    });
    if (this.accountName) {
      this.accountForm.get("name").setValue(typeof this.accountName == "object"  ? this.accountName.name : this.accountName);
    }
  }

  saveAccount() {
    this.accountForm.markAllAsTouched();
    if (this.accountForm.invalid) {
      return;
    }
    const payload = this.accountForm?.value;
    this._cutsheetService.createAccount(payload).subscribe(
      (res) => {
        if (res?.status == 200) {
          this.activeModal.close();
          this._dialogService.showToast(
            "Account Created Successfully",
            "success"
          );
          const account = {
            createdFrom: this.title,
            id: res?.data,
          };
          this._cutsheetService.accountDetails.next(account);
        } else {
          this._dialogService.showToast(
            "Unable to Create New Account",
            "error"
          );
        }
      },
      (err) => {
        if (err?.error?.status == 400) {
          this._dialogService.showToast(err?.error?.message, "error");
        }
      }
    );
  }
}
